export default "__VITE_ASSET__74387f1a__"